import { render, staticRenderFns } from "./generalinquiryDetails.vue?vue&type=template&id=c76f7b52&scoped=true"
import script from "./generalinquiryDetails.vue?vue&type=script&lang=js"
export * from "./generalinquiryDetails.vue?vue&type=script&lang=js"
import style0 from "./generalinquiryDetails.vue?vue&type=style&index=0&id=c76f7b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76f7b52",
  null
  
)

export default component.exports